import Vue from 'vue'

import _ from 'lodash'

import { mapGetters } from 'vuex'

const Modal = Vue.component(
  'Modal',
  require('_/components/UserInterface/Modal/Modal.vue').default
)

export default {
  /**
   * Define props
   *
   * @type  {Object}
   */
  props: {
    show: {
      default: false,
      type: Boolean,
    },
  },

  /**
   * Set the data property
   *
   * @return  {object}
   */
  data() {
    return {}
  },

  /**
   * Set the components
   *
   * @return  {object}
   */
  components: {
    Modal,
  },

  /**
   * Set the computed properties
   *
   * @type  {object}
   */
  computed: {
    ...mapGetters({
      admin: 'admin/admin',
      ui: 'ui/ui',
    }),
  },

  /**
   * Set the methods
   *
   * @type  {object}
   */
  methods: {
    /**
     * Emmits closed modal event to parent component
     *
     * @return  {void}
     */
    closeHelpModal() {
      this.$emit('closedHelpModal')
    },
  },

  /**
   * Set the mounted hook
   *
   * @return  {void}
   */
  mounted() {
    this.$nextTick(() => {})
  },
}
